import React, { memo } from 'react';

import isEqual from 'lodash/isEqual';
import Loadable from 'react-loadable';

import UFOLoadHold from '@atlaskit/react-ufo/load-hold';
import { GenericErrorPage, HubErrorBoundary } from '@atlassian/company-hub-common';

import type { HubEditorConfigPanelProps } from './hub-editor-config-panel/types';

export const LazyHubEditorConfigPanel: React.ComponentType<HubEditorConfigPanelProps> & Loadable.LoadableComponent = Loadable({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "@atlaskit-internal_hub-editor-config-panel" */
				'./hub-editor-config-panel'
			)
		).HubEditorConfigPanel,
	loading: () => <UFOLoadHold name="editor-config-panel-chunk-loader"></UFOLoadHold>,
});

export const HubEditorConfigPanelEntryPoint: React.MemoExoticComponent<({ localId, closeConfigPanel, contentId, editorActions, editorApi, propsProvider, }: HubEditorConfigPanelProps) => React.JSX.Element | null> = memo(
	({
		localId,
		closeConfigPanel,
		contentId,
		editorActions,
		editorApi,
		propsProvider,
	}: HubEditorConfigPanelProps): React.JSX.Element | null => {
		if (localId) {
			return (
				<HubErrorBoundary
					id="hub-editor-config-panel"
					packageName="@atlassian/hub-editor-config-panel"
					fallback={<GenericErrorPage />}
					shouldForceError={true}
				>
					<LazyHubEditorConfigPanel
						localId={localId}
						closeConfigPanel={closeConfigPanel}
						contentId={contentId}
						editorActions={editorActions}
						editorApi={editorApi}
						propsProvider={propsProvider}
					/>
				</HubErrorBoundary>
			);
		}

		return null;
	},
	isEqual,
);
